module.exports = __webpack_public_path__ + "static/audio/sound_2.80d3f13.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/sound/audio/sound_2.mp3
// module id = qhuT
// module chunks = 0